import { Box, Stack, Typography } from '@mui/material';

import { AA_PROMPT } from '@/karehero-app/explore/tell-us-once/TellUsOnce.content';

// The instruction the capture model would run under, written out.
//
// "It asks like a good CAM would" is the load-bearing claim of this whole
// exploration, and a claim that vague can't be argued with — it either sounds
// obviously right or obviously naive depending on the reader. Putting the
// actual rules on the page turns it into something engineering can price and
// the care team can correct line by line.
//
// Worth noticing while reading it: almost none of these rules are about the
// model. They come from the form schema (what is required, what reveals what)
// and from how a CAM already works. That is the argument for this being
// buildable rather than hopeful.
const AaPrompt = () => (
  <Stack spacing={2.5}>
    <Stack spacing={0.75}>
      <Typography variant='h4'>{AA_PROMPT.title}</Typography>
      <Typography variant='body2' color='text.secondary'>
        {AA_PROMPT.intro}
      </Typography>
    </Stack>

    <Stack spacing={2}>
      {AA_PROMPT.blocks.map((block) => (
        <Box
          sx={{ borderLeft: 2, borderColor: 'custom.neutral.300', pl: 2 }}
          key={block.heading}
        >
          <Stack spacing={1}>
            <Typography variant='overline' color='text.secondary'>
              {block.heading}
            </Typography>
            <Stack spacing={1}>
              {block.lines.map((line, i) => (
                <Typography key={i} variant='body2'>
                  {line}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Box>
      ))}
    </Stack>
  </Stack>
);

AaPrompt.displayName = 'AaPrompt';
export default AaPrompt;
